// @flow
export const filterId: 'orderType' = 'orderType';
